// extracted by mini-css-extract-plugin
export default {"main":"Home_main__4+rG5","nosotros":"Home_nosotros__jqDgJ","carouselDesc":"Home_carouselDesc__GoPmc","description":"Home_description__I2c7B","band":"Home_band__NNiOe"};